import { RefObject, useEffect, useRef } from "react";

export const useElementIntersectionObserver = <T extends HTMLElement>(
    setViewState: React.Dispatch<React.SetStateAction<boolean>>,
    options?: IntersectionObserverInit
  ): RefObject<T> => {
  const refElement = useRef<T>(null);
  
  useEffect(() => {
      const io = new IntersectionObserver((entries, observer) => {
        setViewState(entries[0].isIntersecting);
      }, options);

      if (refElement.current) {
        io.observe(refElement.current);
      }

      return () => io.disconnect();
  }, [options, setViewState]);

  return refElement;
};